'use strict';

customerZone.controller('CreateCustomerController', ['$log', 'utils', 'CustomerService', 'AuthenticationService',
    'Session', 'errorCode', 'ControllerBase', function($log, utils, CustomerService, AuthenticationService, Session,
    errorCode, ControllerBase){

        var self = this;
        ControllerBase.call(this, utils);

        self.creation = {};

        // handling errors only known after a request has been made
        self.uwaValidationErrors = {};

        self.data = {
            msisdn: null,
            verificationCode: null,
            account: {}
        };

        if (Session.authenticated()){
            jim.goHome();
        }

        self.requestVerificationCode = utils.once(function(){
            self.codeConfirmed = false;
            self.codeSent = false;
            return self.recaptcha.execute()
                .then(function(recaptchaResponse){
                    var sentFor = self.data.msisdn;
                    return CustomerService.requestVerificationCode(sentFor, recaptchaResponse)
                        .then(function(){
                            self.codeSent = sentFor;
                        });
                })
                .catch(function(error){
                    if (errorCode.is(error, errorCode.UNKNOWN_USER)){
                        utils.showError('subscription_for_number_not_found_try_again');
                    }
                    else {
                        $log.error('Error requesting verification code', error);
                        utils.showError();
                    }
                });
        });

        self.confirmVerificationCode = utils.once(function(){
            return CustomerService.createAccount(self.data.msisdn, self.data.verificationCode)
                .then(function(_creation_){
                    self.creation = _creation_;
                    self.codeConfirmed = !!self.creation;
                })
                .catch(function(error){
                    if (errorCode.is(error, errorCode.INVALID_RESET_CODE)){
                        utils.showError('invalid_phone_verification_code_correct_or_request_new');
                    }
                    else if (errorCode.is(error, errorCode.INVALID_PHONE_VERIFICATION_CODE)){
                        utils.showError('invalid_phone_verification_code_correct_or_request_new');
                    }
                    else {
                        $log.error('Error confirming verification code', error);
                        utils.showError();
                    }
                });
        });

        self.createCustomer = function(){

            self.uwaValidationErrors = {};

            var createPromise = self.creation.complete()
                .then(function(){
                    var loginPromise = AuthenticationService.login(self.data.msisdn,
                        self.creation.password).then(function(){ utils.goToHome(); });
                    utils.showBusy(loginPromise, 'logging_in_automatically', 'automatically_logged_in',
                        'automatic_login_failed');
                    return loginPromise;
                })
                .catch(function(error){
                    self.handleValidationErrors(error, [
                        {code: errorCode.EMAIL_ADDRESS_ALREADY_IN_USE, on: 'email',
                            message: 'email_already_used'},
                        {code: errorCode.EMAIL_ADDRESS_ALREADY_IN_USE, field: 'email', on: 'email',
                            message: 'email_already_used'},
                        {code: errorCode.INVALID_VALUE, field: 'email', on: 'email',
                            message: 'email_invalid'},
                        {code: errorCode.PASSWORD_TOO_COMMON, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_common'},
                        {code: errorCode.PASSWORD_ENTIRELY_NUMERIC, field: 'newPassword', on: 'newPassword',
                            message: 'password_entirely_numeric_error_message'},
                        {code: errorCode.PASSWORD_TOO_SIMILAR, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_similar_error_message'},
                        {code: errorCode.PASSWORD_SIMILAR_TO_DETAILS, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_similar_to_details_error_message'},
                        {code: errorCode.INVALID_VALUE, field: 'postcode', on: 'postcode',
                            message: 'not_a_valid_belgian_postcode'}
                    ], busy);
                    if (errorCode.is(error, errorCode.INVALID_GRANT)){
                        busy.showError('your_reset_token_expired__ask_a_new_one');
                        self.codeConfirmed = false;
                        self.codeSent = false;
                    }
                    throw error;
                });
            var busy = utils.showBusy(createPromise, 'creating_account', 'account_created');

            return busy.wrappedPromise;
        };

    }]);
